import { Link } from 'react-router-dom';
import type { LucideIcon } from 'lucide-react';
import { ChevronRight } from 'lucide-react';
import { Card, CardContent } from './card';

type MetricCardProps = {
  icon: LucideIcon;
  value: string | number;
  title: string;
  hint?: string;
  to?: string;
};

export default function MetricCard({ icon: Icon, value, title, hint, to }: MetricCardProps) {
  const inner = (
    <Card className={to ? 'transition-colors hover:border-primary/30' : ''}>
      <CardContent className="p-4">
        <div className="flex items-start justify-between gap-2">
          <div className="flex h-9 w-9 shrink-0 items-center justify-center rounded-lg bg-primary/10 text-primary">
            <Icon className="h-4 w-4" strokeWidth={2} />
          </div>
          {to && <ChevronRight className="h-4 w-4 shrink-0 text-primary" />}
        </div>
        <p className="mt-3 text-2xl font-bold tabular-nums text-foreground">{value}</p>
        <p className="mt-0.5 text-sm font-medium text-foreground">{title}</p>
        {hint && <p className="mt-0.5 text-xs text-muted-foreground">{hint}</p>}
      </CardContent>
    </Card>
  );

  if (to) return <Link to={to}>{inner}</Link>;
  return inner;
}
